import { combineReducers } from '@reduxjs/toolkit';
import { reducer as importReducer } from './import';

export * from './import';

const absenceReducer = combineReducers({
  import: importReducer,
});

export default absenceReducer;
